// removed by extract-text-webpack-plugin
module.exports = {"root":"_1mJO__1m","flag":"_18_Mz_18","label":"_2_wON_2_","size16":"_32uRT_32","size18":"_3En0Q_3E","size24":"_1SEQ6_1S","size28":"_3RuTb_3R"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/CountryLabel/CountryLabel.css
// module id = 729
// module chunks = 0